import React from 'react';

// Inlined SVG rather than a `ReactComponent` svg import: @svgr/webpack v8 (OHIF
// 3.10) no longer emits the `ReactComponent` named export by default, so the old
// `import { ReactComponent as AiIcon } from './predictionsPanelIcon.svg'` resolved
// to `undefined` and the panel tabs rendered with no icon.
// `#c95cb8` == the `primary.active` token (DeepHealth's orchid on the dark viewer).
// That utility class is purged from the active ui-next stylesheet (it doesn't scan
// gleamer/*), so the color is inlined here to keep the icon visible.
const ICON_COLOR = '#c95cb8';

export function PredictionsPanelIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke={ICON_COLOR}
      width={22}
      height={22}
      {...props}
    >
      <path
        stroke={ICON_COLOR}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"
      />
      <text
        stroke={ICON_COLOR}
        fontSize={10}
        fill={ICON_COLOR}
        fontFamily="liberation-sans, sans-serif"
        strokeWidth={0.7}
        fontWeight="lighter"
        textAnchor="middle"
        x={12}
        y={15}
      >
        AI
      </text>
    </svg>
  );
}
